export default __webpack_public_path__ + "static/media/nilSignature.7309e8d4.svg";